var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:['blw-control blw-button', _vm.size, { 'dark-text': _vm.darkText }],style:(_vm.disabledStyles),attrs:{"id":"blw-button"}},'v-btn',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }